import { configureStore } from '@reduxjs/toolkit';
import { pubApi } from './api/cache';
import appStateSlice from './slices/appStateSlice';
import { useSelector } from 'react-redux';
import { loginApi } from './api/login';

export const store = configureStore({
    reducer: {
        [pubApi.reducerPath]: pubApi.reducer,
        [loginApi.reducerPath]: loginApi.reducer,
        appState: appStateSlice
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ serializableCheck: false }).concat(pubApi.middleware).concat(loginApi.middleware),
});

export const useAppSelector = useSelector;